export const buildSelectionStateFromAccount = (account) => {
  if (account?.broker === "virtual") {
    return {
      isVirtualAccount: true,
      virtualAccountId: account.virtualAccountId ?? null,
      sourceAccount: account.sourceAccount ?? null,
      linkedAccounts: account.linkedAccounts || [],
      selectedAccount: account.sourceAccount
        ? {
            ...account.sourceAccount,
            name: account.name,
            isVirtual: true,
            virtualAccountId: account.virtualAccountId,
          }
        : null,
    };
  }

  return {
    isVirtualAccount: false,
    virtualAccountId: null,
    sourceAccount: null,
    linkedAccounts: [],
    selectedAccount: account || null,
  };
};

export const getSelectionKey = (selectionState) => {
  if (!selectionState?.selectedAccount) return null;
  if (selectionState.isVirtualAccount) {
    const id =
      selectionState.virtualAccountId ??
      selectionState.selectedAccount.virtualAccountId;
    return id != null ? `virtual:${id}` : null;
  }
  const { broker, account } = selectionState.selectedAccount;
  return broker && account ? `real:${broker}:${account}` : null;
};

export const reduceAccountSelection = (currentSelectionState, clickedAccount) => {
  const nextSelectionState = buildSelectionStateFromAccount(clickedAccount);
  const currentKey = getSelectionKey(currentSelectionState);
  const nextKey = getSelectionKey(nextSelectionState);

  if (currentKey && nextKey && currentKey === nextKey) {
    return {
      isVirtualAccount: false,
      virtualAccountId: null,
      sourceAccount: null,
      linkedAccounts: [],
      selectedAccount: null,
    };
  }

  return nextSelectionState;
};
